module.exports = __webpack_public_path__ + "files/93dac03aabf01e914c315958aa771a29.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/food_drink-3.png
// module id = 511
// module chunks = 76